module.exports = __webpack_public_path__ + "img/dbe8ea4.jpg";